import React, { useState } from 'react';
import { Download, FilePlus, ArrowLeft, X  } from "lucide-react";
import { useNavigate } from 'react-router-dom';

const AudioIssueVisaualization = () => {
    const navigate = useNavigate();


    const handleBackClick = () => {
    navigate('/audioReviewRecord');
  };
  
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  return (
    <div className="min-h-screen w-full bg-black text-white  md:p-4 lg:p-0 overflow-auto flex flex-col">
      <div className="flex flex-col justify-between items-left   lg:mb-4 px-2 md:px-4 lg:px-0 gap-3 lg:gap-4 mt-3 flex-shrink-0">
        <div className="flex items-center sm:gap-20 gap-5 p-2 ml-3 -mb-5">
          <ArrowLeft
            className="w-5 h-5 md:w-9 md:h-9 text-white -ml-4"
            strokeWidth={2}
            onClick={handleBackClick}
          />
          <h1 className="text-xl md:text-2xl lg:text-3xl font-bold text-white">
            Model X100
          </h1>
        </div>
        <div className="flex flex-wrap justify-left sm:gap-10 gap-2 w-full sm:w-auto p-2">
          <button
            className="
      w-full md:w-auto
      px-4 py-2
      md:px-6 md:py-3
      bg-gray-800 text-white text-xs md:text-lg font-medium rounded-md
      hover:bg-gray-700 transition-colors border border-gray-600
      flex items-center gap-2
    "
          >
            <FilePlus className="w-6 h-6" />
            Download TXT
          </button>
          <button
            className="
      w-full md:w-auto
      px-4 py-2
      md:px-6 md:py-3
      bg-gray-800 text-white text-xs md:text-lg font-medium rounded-md
      hover:bg-gray-700 transition-colors border border-gray-600
      flex items-center gap-2
    "
          >
            <FilePlus className="w-6 h-6" />
            Download Equal-Space Diagrams
          </button>
          <button
            className="
      w-full md:w-auto
      px-4 py-2
      md:px-6 md:py-3
      bg-blue-500 text-white text-xs md:text-lg font-medium rounded-md
      hover:bg-gray-700 transition-colors border border-gray-600
      flex items-center gap-2
    "
          >
            <Download className="w-6 h-6" />
            Download All
          </button>
        </div>
      </div>
      <div className="bg-gray-900 rounded-lg shadow-lg p-4 md:p-6 lg:p-5 mx-2 md:mx-4 lg:mx-0 flex-1  mb-5 md:mb-1">
        <h2 className="text-base md:text-lg lg:text-xl font-semibold text-white mb-1 md:mb-1 border-b border-gray-900">Detection Results</h2>
        <p className="text-gray-300 mb-1 md:mb-1 text-sm md:text-lg leading-relaxed">
          1. The possible audio buzz may occur at the fundamental frequency of 95 Hz, as indicated by the spectrogram and
          harmonic record shown below.
        </p>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6 mb-3 md:mb-4">
          <div className="bg-gray-800 rounded-lg flex justify-center items-center min-h-[200px] md:min-h-[280px] lg:min-h-[400px] w-full cursor-pointer" onClick={() => setIsPreviewOpen(true)}>
            <img
               src="test.png"
               // src="logo512.png"
               
              alt="Spectrogram showing audio buzz at 95 Hz"
               className="max-w-full max-h-full object-contain"
             // className="h-72 sm:h-96 lg:h-[500px] max-w-full object-contain"

            />
        

          </div>
          <div className="overflow-x-auto w-full mb-5 ">
            <table className="min-w-full bg-black-800 border border-gray-300 rounded-lg">
              <thead className="bg-black-700">
                <tr>
                  <th className="px-2 md:px-4 sm:py-6 text-left text-md font-medium text-white uppercase tracking-wider border-b border-r border-gray-300">

                  </th>
                  <th className="px-2 md:px-4 sm:py-6 text-left text-xs sm:text-sm md:text-base  font-medium text-white uppercase tracking-wider border-b border-r border-gray-300">
                    Frequency (Hz)
                  </th>
                  <th className="px-2 md:px-4 sm:py-6 text-left  text-xs sm:text-sm md:text-base  font-medium text-white uppercase tracking-wider border-b border-r border-gray-300">
                    Energy (dB)
                  </th>
                </tr>
              </thead>

              <tbody className="divide-y divide-x divide-gray-300 ">
                <tr>
                  <td className="px-2 md:px-4 sm:py-4 text-md text-white border-r border-gray-300">Basic Frequency</td>
                  <td className="px-2 md:px-4 sm:py-4 text-md text-white border-r border-gray-300">95</td>
                  <td className="px-2 md:px-4 sm:py-4 text-md text-white border-r border-gray-300">-38</td>
                </tr>

                <tr>
                  <td className="px-2 md:px-4 sm:py-4 text-md text-white border-r border-gray-300">Second Harmonic</td>
                  <td className="px-2 md:px-4 py-2 text-md text-white border-r border-gray-300">190</td>
                  <td className="px-2 md:px-4 py-2 text-md text-white border-r border-gray-300">-56</td>
                </tr>

                <tr>
                  <td className="px-2 md:px-4 sm:py-4 text-md text-white border-r border-gray-300">Third Harmonic</td>
                  <td className="px-2 md:px-4 py-2 text-md text-white border-r border-gray-300">285</td>
                  <td className="px-2 md:px-4 py-2 text-md text-white border-r border-gray-300">-43</td>
                </tr>

                <tr>
                  <td className="px-2 md:px-4 sm:py-4 text-md text-white border-r border-gray-300">Fourth Harmonic</td>
                  <td className="px-2 md:px-4 py-2 text-md text-white border-r border-gray-300">380</td>
                  <td className="px-2 md:px-4 py-2 text-md text-white border-r border-gray-300">-47</td>
                </tr>

                <tr>
                  <td className="px-2 md:px-4 sm:py-4 text-md text-white border-r border-gray-300">Fifth Harmonic</td>
                  <td className="px-2 md:px-4 py-2 text-md text-white border-r border-gray-300">475</td>
                  <td className="px-2 md:px-4 py-2 text-md text-white border-r border-gray-300">-53</td>
                </tr>
              </tbody>
            </table>
            <table className="min-w-full bg-black-800 divide-x divide-y divide-gray-300 rounded-lg mt-6 border border-gray-300">
              <thead className="bg-black-700 ">
                <tr>
                  <th className="px-2 md:px-4 py-3 text-left text-md font-medium text-white uppercase tracking-wider border-r border-gray-300 ">

                  </th>
                  <th className="px-2 md:px-4 py-3 text-left text-xs sm:text-sm md:text-base  font-medium text-white uppercase tracking-wider border-r border-gray-300 ">
                    Energy (dB)
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-x divide-gray-300">
                <tr className="bg-black-700 ">
                  <td className="px-2 md:px-4 py-3 text-md font-medium text-white border-r border-gray-300">
                    AVG (excluding basic frequency)
                  </td>
                  <td className="px-2 md:px-4 py-3 text-md font-medium text-white border-r border-gray-300">
                    -75
                  </td>
                </tr>
                <tr className="bg-black-700">
                  <td className="px-2 md:px-4 py-3 text-md font-medium text-white border-r border-gray-300">
                    Standard Deviation
                  </td>
                  <td className="px-2 md:px-4 py-3 text-md font-medium text-white border-r border-gray-300">
                    14
                  </td>
                </tr>
                <tr className="bg-black-700">
                  <td className="px-2 md:px-4 py-3 text-md font-medium text-white border-r border-gray-300">
                    AVG Standard Deviation
                  </td>
                  <td className="px-2 md:px-4 py-3 text-md font-medium text-white border-r border-gray-300">
                    -61
                  </td>
                </tr>
              </tbody>
            </table>
            <p className="sm:text-xl text-white mt-1 md:mt-2 text-sm ">
              Remark: Calculation of both the average and standard deviation excludes the fundamental frequency.
            </p>
          </div>
        </div>
      </div>

<div
  className="
    fixed bottom-0 left-0 right-0
    w-full
    py-4 md:py-4 lg:py-6 
    bg-black z-50
    px-4 md:px-6 lg:px-8
    flex justify-center items-center gap-2
    text-xs md:text-sm text-gray-400
    border-t border-gray-500
    pointer-events-auto
  "
  style={{ paddingBottom: 'env(safe-area-inset-bottom)' }} // keeps above iPhone home bar
>
  <button
    className="px-3 py-2 rounded hover:bg-gray-700 transition-colors  border border-gray-500 mb-2 -mt-3"
    disabled
    aria-label="Previous"
  >
    &lt;
  </button>

  <span className="min-w-[55px] text-center mb-2 -mt-3 ">5 / 5</span>

  <button
    className="px-3 py-2 rounded hover:bg-gray-700 transition-colors border border-gray-500 mb-2 -mt-3"
    disabled
    aria-label="Next"
  >
    &gt;
  </button>
</div>

      {/* Image Preview Modal */}
      {isPreviewOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4"
          onClick={() => setIsPreviewOpen(false)}
        >
          <div 
            className="relative max-w-6xl max-h-[90vh] w-full h-full flex items-center justify-center"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src="test.png"
              alt="Spectrogram showing audio buzz at 95 Hz"
              className="max-w-full max-h-full object-contain"
            />
           

            <button
  onClick={() => setIsPreviewOpen(false)}
  className="
    absolute 
    top-2 right-2     /* Mobile: above & away from image */
    md:top-1 md:right-0  /* Web: move more right & down */
    bg-gray-800 text-white
    hover:bg-gray-700
    rounded-full p-2
    transition-colors 
    z-20 shadow-lg
  "
>
  <X className="w-6 h-6 md:w-8 md:h-8" strokeWidth={2.5} />
</button>

          </div>
        </div>
      )}
    </div>
  );
};

export default AudioIssueVisaualization;

